module.exports = __webpack_public_path__ + "img/MillRiverCluster.6305cc4a.jpg";